// @ts-nocheck
(function () {
  // Solo activo en la homepage (lt-nav es el centinela)
  if (!document.getElementById('lt-nav')) return;

  /* ── Cortina intro ─────────────────────────────────────────── */
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let introStarted = false;

  function startIntro() {
    if (introStarted) return;
    introStarted = true;
    setTimeout(function () {
      document.body.classList.add('hero-go', 'curtain-go');
    }, 620);
    setTimeout(function () {
      document.body.classList.remove('intro');
      document.body.classList.add('curtain-done');
      onScroll();
    }, 1860);
  }

  if (!prefersReduced) {
    document.body.classList.add('intro');
    if (document.readyState === 'complete') startIntro();
    else window.addEventListener('load', startIntro);
  }

  /* ── Scroll: nav + reveals + stagger + parallax ────────────── */
  var nav    = document.getElementById('lt-nav');
  var heroEl = document.getElementById('lt-top');
  var reveals    = Array.from(document.querySelectorAll('.reveal, .reveal-rise'));
  var staggers   = Array.from(document.querySelectorAll('[data-stagger]'));
  var heroImg    = document.querySelector('.hero-img');
  var parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
  var ticking = false;

  staggers.forEach(function (g) {
    Array.from(g.children).forEach(function (k, i) {
      k.style.setProperty('--d', i * 80 + 'ms');
    });
  });

  function update() {
    ticking = false;
    var y  = window.scrollY || 0;
    var vh = window.innerHeight;

    if (nav && heroEl) {
      nav.dataset.mode = y > heroEl.offsetHeight - 90 ? 'solid' : 'over';
    }

    var trigger = vh * 0.86;
    reveals = reveals.filter(function (el) {
      if (el.getBoundingClientRect().top < trigger) {
        el.classList.add('in');
        return false;
      }
      return true;
    });
    staggers = staggers.filter(function (g) {
      if (g.getBoundingClientRect().top < trigger) {
        g.classList.add('in');
        return false;
      }
      return true;
    });

    if (heroImg && !document.body.classList.contains('intro')) {
      heroImg.style.transform = 'translateY(' + y * 0.08 + 'px) scale(1.08)';
    }

    parallaxEls.forEach(function (el) {
      var r   = el.parentElement.getBoundingClientRect();
      var off = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translateY(' + off * -parseFloat(el.dataset.parallax) + 'px)';
    });
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();

})();